import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SummaryHeaderBox from './comp/SummaryHeaderBox';
import SummaryHeaderTable from './comp/SummaryHeaderTable';
import SummaryBarChart from './comp/SummaryBarChart';
import SummaryLineChart from './comp/SummaryLineChart';
import Loader from '../../utils/Loader';

const SummaryHeader = ({ report, loggedInUser, queryFields, filter }) => {
  const [subReports, setSubReports] = useState([]);
  const [loading, setLoading] = useState(false);

  // console.log('loggedInUser summary header', loggedInUser);

  // this is for first load
  useEffect(() => {
    if (!report) return;

    let startDate = '';
    let endDate = '';
    if (Array.isArray(queryFields)) {
      startDate = queryFields.filter((each) => each.field === 'startDate');
      endDate = queryFields.filter((each) => each.field === 'endDate');
    }

    if (report) {
      const user = JSON.parse(localStorage.getItem('centralize-admin-data'));
      if (report.subReports && report.subReports.length) {
        setLoading(true);
        async function fetchData() {
          const filtered = report.subReports.filter(
            (e) => e.reportType !== 'multi-tabs-report'
          );
          const data =
            filtered &&
            filtered.map(async (sub, idx) => {
              // if (sub.mainReportId !== report._id) return;

              let query = {
                ...sub.query,
                token: user.accessToken,
                campaignId: loggedInUser ? loggedInUser.campaignId : '',
                startDate: startDate ? startDate[0].value : '',
                endDate: endDate ? endDate[0].value : '',
              };
              // console.log('query -----', query);
              return axios
                .post(sub.endpoint, query)
                .then((data) => {
                  setLoading(false);
                  // console.log('data', data);
                  return {
                    columns: sub.header,
                    rows: data.data.data,
                    colCount: sub.column,
                    tableName: sub.name,
                    mainReportId: sub.mainReportId,
                    reportType: sub.reportType,
                  };
                })
                .catch((err) => {
                  setLoading(false);
                  console.log('error', err);
                });
            });

          return await Promise.all(data);
        }

        fetchData().then((data) => {
          // console.log('data', data);
          const filter = data.filter((each) => each !== undefined);
          setSubReports(filter);
        });
      }
    }
  }, [report, filter]);
  // console.log('queryFields', queryFields);
  // console.log('report', report);
  // console.log('subReports', subReports);

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div className="d-flex flex-wrap">
          {subReports && subReports.length
            ? subReports.map((summaryReport, subReportIdx) => {
                // console.log('summaryReport', summaryReport);
                if (summaryReport) {
                  return (
                    <div
                      key={subReportIdx}
                      className={
                        summaryReport &&
                        summaryReport.colCount &&
                        summaryReport.colCount
                          ? `col-md-${summaryReport.colCount}`
                          : 'col-md-8'
                      }
                    >
                      <div>
                        {summaryReport && summaryReport.tableName ? (
                          <div className="fw-bold">
                            <div> {summaryReport.tableName} </div>
                          </div>
                        ) : null}

                        <div className="mb-5">
                          {summaryReport.reportType === 'Non Action' ||
                          summaryReport.reportType === 'summary-header' ? (
                            <SummaryHeaderBox
                              summaryReport={summaryReport}
                              loading={loading}
                            />
                          ) : summaryReport.reportType ===
                            'summary-header-table' ? (
                            <SummaryHeaderTable
                              summaryReport={summaryReport}
                              loading={loading}
                            />
                          ) : summaryReport.reportType ===
                            'summary-header-bar-chart' ? (
                            <SummaryBarChart
                              summaryReport={summaryReport}
                              loading={loading}
                            />
                          ) : summaryReport.reportType ===
                            'summary-header-line-chart' ? (
                            <SummaryLineChart
                              summaryReport={summaryReport}
                              loading={loading}
                            />
                          ) : null}
                        </div>
                      </div>
                    </div>
                  );
                }
                return null;
              })
            : null}
        </div>
      )}
    </div>
  );
};

export default SummaryHeader;
